export function ElementsNotFound() {
    return (
        <div className="w-full text-center p-3">
            <span className="font-semibold text-lg">Sin Elementos Encontrados</span>
        </div>
    );
}